
import { useState } from "react";
import { Candidate } from "@/types/candidate";

export const useEditCandidateForm = (candidate: Candidate, onSave: (updatedCandidate: Partial<Candidate>) => Promise<void>) => {
  const [formData, setFormData] = useState<Partial<Candidate>>({
    name: candidate.name,
    email: candidate.email,
    phone: candidate.phone || "",
    function: candidate.function || "",
    skills: candidate.skills || [],
    manager: candidate.manager || "",
    status: candidate.status || "Looking",
    linkedin: candidate.linkedin || "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleStatusChange = (value: string) => {
    setFormData(prev => ({ ...prev, status: value }));
  };

  const handleSkillsChange = (skills: string[]) => {
    setFormData(prev => ({ ...prev, skills }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      console.log("Submitting form data:", formData);
      await onSave(formData);
    } catch (error) {
      console.error("Error updating candidate:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    isSubmitting,
    handleChange,
    handleStatusChange,
    handleSkillsChange,
    handleSubmit
  };
};
